export const caseInsensitive = (
  valueA,
  valueB,
  nodeA,
  nodeB,
  isDescending
) => {
  const strA = valueA == null ? '' : String(valueA).trim();
  const strB = valueB == null ? '' : String(valueB).trim();

  const aIsEmpty = strA === '';
  const bIsEmpty = strB === '';

  if (aIsEmpty && bIsEmpty) return 0;

  if (aIsEmpty) return isDescending ? -1 : 1;
  if (bIsEmpty) return isDescending ? 1 : -1;

  return strA.toLowerCase().localeCompare(strB.toLowerCase());
};

/** Capitalize first letter of a word */
export const upperFirst = (string = '') => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
};
